import React from 'react';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';


export const GlobalDBARegistriesGSTInfoComponent = ({ handleInnerFormChange, selectedDba }: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                     isDisabled
                        label="Legal Entity Name"
                        name="legal_entity_name"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigGst.legal_entity_name',
                                selectedDba?.RegConfigGst
                            )
                        }}
                        type="text"
                        value={selectedDba?.RegConfigGst?.legal_entity_name}
                    />
                    <InputContainer
                     isDisabled
                        label="Business Address"
                        name="business_address"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigGst.business_address',
                                selectedDba?.RegConfigGst
                            )
                        }}
                        type="text"
                        value={selectedDba?.RegConfigGst?.business_address}
                    />
                    <InputContainer
                     isDisabled
                        label="GST No"
                        name="gst_no"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigGst.gst_no',
                                selectedDba?.RegConfigGst
                            )
                        }}
                        type="text"
                        value={selectedDba?.RegConfigGst?.gst_no}
                    />
                    <InputContainer
                     isDisabled
                        label="City Code"
                        onValueChange={(newValue: any) => {
                            const citycodeData: any = newValue.map((option: any) => option?.id || '')
                            handleInnerFormChange(
                                citycodeData,
                                'RegConfigGst.city_code',
                                selectedDba?.RegConfigGst

                            );
                        }}
                        type="multiselectText"
                        value={selectedDba?.RegConfigGst?.city_code}
                    />
                </div>
            }
            expandedPanel="gst info"
            headerTitle="GST Info"
        />
    </>
)

export default GlobalDBARegistriesGSTInfoComponent;